import React from 'react'

const DownArrowSolid = () => {
  return (
    <svg
      width="8"
      height="5"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.29977 4.3L0.699768 1.7C0.383101 1.38333 0.312435 1.021 0.487768 0.613C0.662435 0.204333 0.974768 0 1.42477 0H6.57477C7.02477 0 7.3371 0.204333 7.51177 0.613C7.6871 1.021 7.61643 1.38333 7.29977 1.7L4.69977 4.3C4.59977 4.4 4.49143 4.475 4.37477 4.525C4.2581 4.575 4.1331 4.6 3.99977 4.6C3.86643 4.6 3.74143 4.575 3.62477 4.525C3.5081 4.475 3.39977 4.4 3.29977 4.3Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default DownArrowSolid
